import React from 'react';
import createReactClass from 'create-react-class';
import config from './config/purchaseUnitConfig';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import PurchaseUnitForm from './PurchaseUnitForm';

var AddPurchaseUnit = createReactClass({
  componentWillMount() {
    setViewTitle('Neue Bestelleinheit');
  },

  submitForm(newUnit) {
    let { params } = this.props.match;

    request.post({
      url: config.apiUrl + params.itemId + '/units',
      data: newUnit,
      success: () => {
        this.props.history.push(`/items/${params.itemId}/vendors`);
      }
    });
  },

  render() {
    let { params } = this.props.match;

    const initialModel = {
      id: params.itemId,
      vendorId: params.vendorId,
      name: 'Neue Bestelleinheit',
      stockUnitQuantity: 1,
      externalId: null,
      netPrice: null,
      minPurchaseQuantity: 1
    };

    return (
      <PurchaseUnitForm title="Neue Bestelleinheit" onSubmit={this.submitForm} model={initialModel} />
    );
  }

});

export default AddPurchaseUnit;



// WEBPACK FOOTER //
// ./src/components/purchaseunits/AddPurchaseUnit.js